/* RRM 2026-10-02 (Mason). Behaviour for sections/rrm-main-product.liquid.
   Gallery counter and arrows, size pick to variant resolve, price and
   add-to-cart state. No dependencies, no changes to theme.js.
   2026-10-06: multi-option products (sets) resolve the variant from every
   grid's pick and block add to cart until each size is chosen. */
(function () {
  function init(section) {
    var track = section.querySelector('[data-rrm-track]');
    var counter = section.querySelector('[data-rrm-counter]');
    var slides = track ? track.querySelectorAll('.rrm-im').length : 0;

    if (track && counter && slides) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        counter.textContent = (i + 1) + ' / ' + slides;
      }, { passive: true });
    }
    section.querySelectorAll('[data-rrm-arrow]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!track) return;
        track.scrollBy({ left: track.clientWidth * Number(btn.dataset.rrmArrow), behavior: 'smooth' });
      });
    });

    var dataEl = section.querySelector('[data-rrm-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    /* 2026-10-06: one grid per option. Sets (full tracksuits) carry a
       hoodie size and a jogger size; a single-size product has one grid and
       behaves exactly as before. */
    var grids = Array.prototype.slice.call(section.querySelectorAll('[data-rrm-sizes]'));
    var idSelect = section.querySelector('[data-rrm-id]');
    var priceEl = section.querySelector('[data-rrm-price]');
    var atc = section.querySelector('[data-rrm-atc]');
    var needsPick = !!(atc && atc.dataset.rrmNeedsPick === '1');
    var picked = {};
    var stockEl = section.querySelector('[data-rrm-stock]');
    var lowAt = Number(section.dataset.lowStock || 0);

    /* 2026-10-06: low stock line (Cole Buxton form, monochrome). Shows only
       when the resolved variant is Shopify-tracked, in stock and at or under
       the threshold; otherwise the line is hidden, the page stays quiet. */
    function paintStock(v) {
      if (!stockEl) return;
      var low = v && typeof v.qty === 'number' && v.qty > 0 && lowAt > 0 && v.qty <= lowAt;
      if (!low) { stockEl.hidden = true; stockEl.textContent = ''; return; }
      var where = grids.length === 1 ? ' in ' + v.options[Number(grids[0].dataset.optionIndex)] : '';
      stockEl.textContent = 'Low stock, ' + v.qty + ' left' + where;
      stockEl.hidden = false;
    }

    grids.forEach(function (g) {
      var idx = Number(g.dataset.optionIndex);
      var on = g.querySelector('.rrm-sz[aria-pressed="true"]');
      if (on) picked[idx] = on.dataset.rrmSize;
    });

    function allPicked() {
      return grids.every(function (g) { return picked[Number(g.dataset.optionIndex)] != null; });
    }

    function resolve() {
      var exact = variants.find(function (v) {
        return grids.every(function (g) {
          var i = Number(g.dataset.optionIndex);
          return picked[i] == null || v.options[i] === picked[i];
        });
      });
      return exact || null;
    }

    function paint() {
      grids.forEach(function (g) {
        var i = Number(g.dataset.optionIndex);
        g.querySelectorAll('.rrm-sz').forEach(function (b) {
          b.setAttribute('aria-pressed', b.dataset.rrmSize === picked[i] ? 'true' : 'false');
        });
      });
    }

    function apply(v) {
      if (!v) return;
      if (idSelect) {
        idSelect.value = String(v.id);
        /* The standard signals restock and tracking apps listen for. */
        idSelect.dispatchEvent(new Event('change', { bubbles: true }));
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', String(v.id));
          window.history.replaceState({}, '', url.toString());
        } catch (err) { /* older Safari, non-fatal */ }
      }
      if (priceEl) {
        priceEl.innerHTML = (v.compare_at ? '<s>' + v.compare_at + '</s>' : '') + v.price;
      }
      paintStock(v);
      if (atc) {
        atc.disabled = false;
        atc.textContent = v.available ? 'Add to cart' : 'Notify me';
        atc.dataset.rrmSoldOut = v.available ? '' : '1';
        atc.dataset.rrmNeedsPick = '';
        needsPick = false;
      }
    }

    function firstUnpicked() {
      return grids.find(function (g) { return picked[Number(g.dataset.optionIndex)] == null; }) || null;
    }

    function nudge(g) {
      if (!g) return;
      g.scrollIntoView({ block: 'center', behavior: 'smooth' });
      g.classList.remove('rrm-nudge');
      void g.offsetWidth;
      g.classList.add('rrm-nudge');
    }

    grids.forEach(function (g) {
      var idx = Number(g.dataset.optionIndex);
      g.querySelectorAll('.rrm-sz').forEach(function (btn) {
        btn.addEventListener('click', function () {
          picked[idx] = btn.dataset.rrmSize;
          paint();
          if (!allPicked()) {
            paintStock(null);
            if (atc) { atc.textContent = 'Select sizes'; atc.dataset.rrmNeedsPick = '1'; }
            needsPick = true;
            return;
          }
          var v = resolve();
          if (v) { apply(v); return; }
          /* No variant carries this combination (deleted in admin). Keep the
             other picks, show the state honestly. */
          paintStock(null);
          if (atc) { atc.textContent = 'Unavailable'; atc.dataset.rrmSoldOut = '1'; }
        });
      });
    });

    function openNotify() {
      /* The restock app on this store is the notify-me (Hengam ReStock)
         embed. Verified 2026-10-03: it portals a
         .restock-alerts-notify-button into the product form on BOTH
         templates and clicking it opens its modal. Ours is the only
         visible button (the app's is hidden in rrm-pdp.css), so proxy the
         click; no button rendered, fall back to the Transfer Room. */
      var trigger = document.querySelector('.restock-alerts-notify-button');
      if (trigger) { trigger.click(); return; }
      window.location.href = section.dataset.transferRoom || '/collections/transfer-room';
    }

    var notifyLink = section.querySelector('[data-rrm-notify-link]');
    if (notifyLink) notifyLink.addEventListener('click', openNotify);

    /* Size guide: a native dialog (focus trap, Escape and focus return are
       the platform's). Renders only when no size chart page is set. */
    var szgBtn = section.querySelector('[data-rrm-size-chart]');
    var szg = section.querySelector('[data-rrm-szguide]');
    if (szgBtn && szg && typeof szg.showModal === 'function') {
      szgBtn.addEventListener('click', function () { szg.showModal(); });
      var szgClose = szg.querySelector('[data-rrm-szguide-close]');
      if (szgClose) szgClose.addEventListener('click', function () { szg.close(); });
      szg.addEventListener('click', function (e) {
        if (e.target === szg) szg.close();
      });
    } else if (szgBtn && szg) {
      /* no dialog support: show it inline as a last resort */
      szgBtn.addEventListener('click', function () { szg.setAttribute('open', ''); });
    }

    var form = section.querySelector('#RrmProductForm');
    if (form && atc) {
      /* Sold-out guard registers FIRST so stopImmediatePropagation can keep
         theme.AjaxProduct from posting a sold-out variant. */
      form.addEventListener('submit', function (e) {
        if (needsPick || atc.dataset.rrmNeedsPick === '1') {
          e.preventDefault();
          e.stopImmediatePropagation();
          nudge(firstUnpicked());
          return;
        }
        if (atc.dataset.rrmSoldOut === '1') {
          e.preventDefault();
          e.stopImmediatePropagation();
          openNotify();
        }
      });
      /* Impulse ajax cart path: theme.AjaxProduct posts to routes.cartAdd and
         dispatches ajaxProduct:added, which theme.CartDrawer (or UpCart, which
         watches the same fetch) answers by opening the drawer. Falls back to
         the plain form POST when the theme bundle is absent. */
      if (window.theme && window.theme.AjaxProduct &&
          window.theme.settings && window.theme.settings.cartType === 'drawer') {
        new window.theme.AjaxProduct(form, '.rrm-patc');
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-section-type="rrm-main-product"]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
